import React from 'react';
import { Controller } from 'react-hook-form';
import { observer } from 'mobx-react';
import SelectSearch from '@alfa-retail-react/components/select-search';
import { useFormContext } from '@alfa-retail-react/components/form-hook';

import { WEB_VISOR_DISABLE, WEB_VISOR_HIDE } from 'app/utils/AnalyticsUtils';
import { OrderFormValues } from 'app/logic/pages/order/OrderPage';
import { ReferenceService } from 'app/service/ReferenceService';
import { Reference } from 'app/model/Reference';
import { BirthPlaceFormStore } from 'app/logic/pages/order/BirthPlaceFormStore';
import { useIsDesktop } from 'app/utils/useWindowType';
import { ValidationRules } from 'app/form/ValidationRules';

export interface BirthCountryFormItemProps {
    /**
     * Хранилище состояния, содержадщего информацию о месте рождения пользователя.
     */
    formStore: BirthPlaceFormStore;
}

/**
 * Компонент выбора страны рождения.
 */
export const BirthCountryFormItem = observer(
    <T, TT>({ formStore }: BirthCountryFormItemProps) => {
        const BIRTH_COUNTRY_FORM_ITEM_NAME = 'birthCountryCode';
        const { control, handleMultipleErrors, setFieldElement } =
            useFormContext<OrderFormValues>();

        const PLACEHOLDER = 'Страна';

        const [isDesktop] = useIsDesktop();
        const referenceService = new ReferenceService();
        const OptionRenderer = (value: { name: string, id: string }) => <div key={value.id}>{value.name}</div>;
        const updateReference = (value: string) =>
            referenceService.getCountriesReference(
                value,
            );

        return (
            <Controller<OrderFormValues>
                control={control}
                defaultValue={formStore.birthCountry}
                name={BIRTH_COUNTRY_FORM_ITEM_NAME}
                rules={{ required: ValidationRules.required() }}
                render={({ field, fieldState }) => {
                    return (
                        <SelectSearch<Reference>
                            className={WEB_VISOR_HIDE}
                            componentRef={(element) => {
                                field.ref(element);
                                setFieldElement(
                                    BIRTH_COUNTRY_FORM_ITEM_NAME,
                                    element,
                                );
                            }}
                            isDesktop={isDesktop}
                            value={field.value as Reference}
                            optionKey={(value) => value.id}
                            selectedOptionTooltipRenderer={OptionRenderer}
                            selectedOptionRenderer={OptionRenderer}
                            optionRenderer={OptionRenderer}
                            filter={updateReference}
                            updateData={updateReference}
                            error={handleMultipleErrors(fieldState.error)}
                            onBlur={(value) => {
                                field.onChange(value);
                                field.onBlur();
                            }}
                            label={PLACEHOLDER}
                            onChange={(locality) => {
                                field.onChange(locality);
                                formStore.setBirthCountry(locality);
                            }}
                        />
                    );
                }}
            />
        );
    },
);
